import Api from '@/services/Api';

export default {
  updateCoD4(serverId) {
    return Api().get('q3serverinfo', {
      params: {
        id: serverId,
      },
    });
  },
  updateCSGO(serverId) {
    return Api().get('csgoserverinfo', {
      params: {
        id: serverId,
      },
    });
  },
};
